import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d22c97d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "workout-form" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "form-items" }
const _hoisted_4 = {
  key: 0,
  class: "form-item-radio"
}
const _hoisted_5 = ["checked", "disabled"]
const _hoisted_6 = { for: "withGpx" }
const _hoisted_7 = ["checked", "disabled"]
const _hoisted_8 = { for: "withoutGpx" }
const _hoisted_9 = { class: "form-item" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 1,
  class: "form-item"
}
const _hoisted_13 = { for: "gpxFile" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "files-help info-box" }
const _hoisted_16 = {
  key: 2,
  class: "form-item"
}
const _hoisted_17 = { for: "title" }
const _hoisted_18 = ["required", "disabled"]
const _hoisted_19 = { key: 3 }
const _hoisted_20 = { class: "workout-date-duration" }
const _hoisted_21 = { class: "form-item" }
const _hoisted_22 = { class: "workout-date-time" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "form-item" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_28 = ["disabled"]
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { class: "form-item" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = { class: "form-item" }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = {
  key: 2,
  class: "form-buttons"
}
const _hoisted_36 = ["disabled"]
const _hoisted_37 = ["onClick"]

import {
    ComputedRef,
    computed,
    reactive,
    ref,
    toRefs,
    watch,
    onMounted,
    onUnmounted,
    withDefaults,
  } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { useRouter } from 'vue-router'

  import { ROOT_STORE, WORKOUTS_STORE } from '@/store/constants'
  import { TAppConfig } from '@/types/application'
  import { ISport } from '@/types/sports'
  import { IUserProfile } from '@/types/user'
  import { IWorkout, IWorkoutForm } from '@/types/workouts'
  import { useStore } from '@/use/useStore'
  import { formatWorkoutDate, getDateWithTZ } from '@/utils/dates'
  import { getReadableFileSize } from '@/utils/files'
  import { translateSports } from '@/utils/sports'
  import { convertDistance } from '@/utils/units'

  interface Props {
    authUser: IUserProfile
    sports: ISport[]
    isCreation?: boolean
    loading?: boolean
    workout?: IWorkout
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    authUser: null,
    sports: null,
    isCreation: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    workout: { default: () => ({} as IWorkout) }
  },
  setup(__props: any) {

const props = __props as { authUser: IUserProfile, sports: ISport[], isCreation: boolean, loading: boolean, workout: IWorkout }

  

  const { t } = useI18n()
  const store = useStore()
  const router = useRouter()

  const { authUser, workout, isCreation, loading } = toRefs(props)
  const translatedSports: ComputedRef<ISport[]> = computed(() =>
    translateSports(
      props.sports,
      t,
      true,
      workout.value.id ? [workout.value.sport_id] : null
    )
  )
  const appConfig: ComputedRef<TAppConfig> = computed(
    () => store.getters[ROOT_STORE.GETTERS.APP_CONFIG]
  )
  const fileSizeLimit = appConfig.value.max_single_file_size
    ? getReadableFileSize(appConfig.value.max_single_file_size)
    : ''
  const gpx_limit_import = appConfig.value.gpx_limit_import
  const zipSizeLimit = appConfig.value.max_zip_file_size
    ? getReadableFileSize(appConfig.value.max_zip_file_size)
    : ''
  const errorMessages: ComputedRef<string | string[] | null> = computed(
    () => store.getters[ROOT_STORE.GETTERS.ERROR_MESSAGES]
  )
  const workoutForm = reactive({
    sport_id: '',
    title: '',
    notes: '',
    workoutDate: '',
    workoutTime: '',
    workoutDurationHour: '',
    workoutDurationMinutes: '',
    workoutDurationSeconds: '',
    workoutDistance: '',
  })
  let withGpx = ref(
    props.workout.id ? props.workout.with_gpx : props.isCreation
  )
  let gpxFile: File | null = null
  const formErrors = ref(false)

  onMounted(() => {
    if (props.workout.id) {
      formatWorkoutForm(props.workout)
    }
  })

  function updateNotes(value: string) {
    workoutForm.notes = value
  }
  function updateWithGpx() {
    withGpx.value = !withGpx.value
    formErrors.value = false
  }
  function updateFile(event: Event & { target: HTMLInputElement }) {
    if (event.target.files) {
      gpxFile = event.target.files[0]
    }
  }
  function formatWorkoutForm(workout: IWorkout) {
    workoutForm.sport_id = `${workout.sport_id}`
    workoutForm.title = workout.title
    workoutForm.notes = workout.notes
    if (!workout.with_gpx) {
      const workoutDateTime = formatWorkoutDate(
        getDateWithTZ(workout.workout_date, props.authUser.timezone),
        'yyyy-MM-dd'
      )
      const duration = workout.duration.split(':')
      workoutForm.workoutDistance = `${
        authUser.value.imperial_units
          ? convertDistance(workout.distance, 'km', 'mi', 2)
          : parseFloat(workout.distance.toFixed(2))
      }`
      workoutForm.workoutDate = workoutDateTime.workout_date
      workoutForm.workoutTime = workoutDateTime.workout_time
      workoutForm.workoutDurationHour = duration[0]
      workoutForm.workoutDurationMinutes = duration[1]
      workoutForm.workoutDurationSeconds = duration[2]
    }
  }
  function formatPayload(payload: IWorkoutForm) {
    payload.title = workoutForm.title
    payload.distance = authUser.value.imperial_units
      ? convertDistance(+workoutForm.workoutDistance, 'mi', 'km', 3)
      : +workoutForm.workoutDistance
    payload.duration =
      +workoutForm.workoutDurationHour * 3600 +
      +workoutForm.workoutDurationMinutes * 60 +
      +workoutForm.workoutDurationSeconds
    payload.workout_date = `${workoutForm.workoutDate} ${workoutForm.workoutTime}`
  }
  function updateWorkout() {
    const payload: IWorkoutForm = {
      sport_id: +workoutForm.sport_id,
      notes: workoutForm.notes,
    }
    if (props.workout.id) {
      if (props.workout.with_gpx) {
        payload.title = workoutForm.title
      } else {
        formatPayload(payload)
      }
      store.dispatch(WORKOUTS_STORE.ACTIONS.EDIT_WORKOUT, {
        workoutId: props.workout.id,
        data: payload,
      })
    } else {
      if (withGpx.value) {
        if (!gpxFile) {
          const errorMessage = 'workouts.NO_FILE_PROVIDED'
          store.commit(ROOT_STORE.MUTATIONS.SET_ERROR_MESSAGES, errorMessage)
          return
        }
        payload.file = gpxFile
        store.dispatch(WORKOUTS_STORE.ACTIONS.ADD_WORKOUT, payload)
      } else {
        formatPayload(payload)
        store.dispatch(WORKOUTS_STORE.ACTIONS.ADD_WORKOUT_WITHOUT_GPX, payload)
      }
    }
  }
  function onCancel() {
    if (props.workout.id) {
      router.push({
        name: 'Workout',
        params: { workoutId: props.workout.id },
      })
    } else {
      router.go(-1)
    }
  }
  function invalidateForm() {
    formErrors.value = true
  }

  onUnmounted(() => store.commit(ROOT_STORE.MUTATIONS.EMPTY_ERROR_MESSAGES))

  watch(
    () => props.workout,
    async (
      newWorkout: IWorkout | undefined,
      previousWorkout: IWorkout | undefined
    ) => {
      if (newWorkout !== previousWorkout && newWorkout && newWorkout.id) {
        formatWorkoutForm(newWorkout)
      }
    }
  )

return (_ctx: any,_cache: any) => {
  const _component_CustomTextArea = _resolveComponent("CustomTextArea")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", {
    id: "workout-edition",
    class: _normalizeClass(["center-card center-card with-margin", { 'center-form': _unref(workout) && _unref(workout).with_gpx }])
  }, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t(`workouts.${_unref(isCreation) ? 'ADD' : 'EDIT'}_WORKOUT`)), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("form", {
            class: _normalizeClass({ errors: formErrors.value }),
            onSubmit: _withModifiers(updateWorkout, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_3, [
              (_unref(isCreation))
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", null, [
                      _createElementVNode("input", {
                        id: "withGpx",
                        type: "radio",
                        checked: _unref(withGpx),
                        disabled: _unref(loading),
                        onClick: updateWithGpx
                      }, null, 8, _hoisted_5),
                      _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('workouts.WITH_GPX')), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("input", {
                        id: "withoutGpx",
                        type: "radio",
                        checked: !_unref(withGpx),
                        disabled: _unref(loading),
                        onClick: updateWithGpx
                      }, null, 8, _hoisted_7),
                      _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('workouts.WITHOUT_GPX')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t('workouts.SPORT', 1)) + ": ", 1),
                _withDirectives(_createElementVNode("select", {
                  id: "sport",
                  required: "",
                  onInvalid: invalidateForm,
                  disabled: _unref(loading),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(workoutForm).sport_id) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(translatedSports), (sport) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: sport.id,
                      key: sport.id
                    }, _toDisplayString(sport.translatedLabel), 9, _hoisted_11))
                  }), 128))
                ], 40, _hoisted_10), [
                  [_vModelSelect, _unref(workoutForm).sport_id]
                ])
              ]),
              (_unref(isCreation) && _unref(withGpx))
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('workouts.GPX_FILE')) + " " + _toDisplayString(_ctx.$t('workouts.ZIP_ARCHIVE_DESCRIPTION')) + ": ", 1),
                    _createElementVNode("input", {
                      id: "gpxFile",
                      name: "gpxFile",
                      type: "file",
                      accept: ".gpx, .zip",
                      disabled: _unref(loading),
                      required: "",
                      onInvalid: invalidateForm,
                      onInput: updateFile
                    }, null, 40, _hoisted_14),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", null, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('workouts.GPX_FILE')) + ":", 1),
                        _createElementVNode("ul", null, [
                          _createElementVNode("li", null, _toDisplayString(_ctx.$t('workouts.MAX_SIZE')) + ": " + _toDisplayString(_unref(fileSizeLimit)), 1)
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('workouts.ZIP_ARCHIVE')) + ":", 1),
                        _createElementVNode("ul", null, [
                          _createElementVNode("li", null, _toDisplayString(_ctx.$t('workouts.NO_FOLDER')), 1),
                          _createElementVNode("li", null, _toDisplayString(_ctx.$t('workouts.MAX_FILES')) + ": " + _toDisplayString(_unref(gpx_limit_import)), 1),
                          _createElementVNode("li", null, _toDisplayString(_ctx.$t('workouts.MAX_SIZE')) + ": " + _toDisplayString(_unref(zipSizeLimit)), 1)
                        ])
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('workouts.TITLE')) + ": ", 1),
                    _withDirectives(_createElementVNode("input", {
                      id: "title",
                      name: "title",
                      type: "text",
                      required: !_unref(isCreation),
                      onInvalid: invalidateForm,
                      disabled: _unref(loading),
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(workoutForm).title) = $event))
                    }, null, 40, _hoisted_18), [
                      [_vModelText, _unref(workoutForm).title]
                    ])
                  ])),
              (!_unref(withGpx))
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.$t('workouts.WORKOUT_DATE')) + ":", 1),
                        _createElementVNode("div", _hoisted_22, [
                          _withDirectives(_createElementVNode("input", {
                            id: "workout-date",
                            name: "workout-date",
                            type: "date",
                            required: "",
                            onInvalid: invalidateForm,
                            disabled: _unref(loading),
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(workoutForm).workoutDate) = $event))
                          }, null, 40, _hoisted_23), [
                            [_vModelText, _unref(workoutForm).workoutDate]
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            id: "workout-time",
                            name: "workout-time",
                            class: "workout-time",
                            type: "time",
                            required: "",
                            onInvalid: invalidateForm,
                            disabled: _unref(loading),
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(workoutForm).workoutTime) = $event))
                          }, null, 40, _hoisted_24), [
                            [_vModelText, _unref(workoutForm).workoutTime]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.$t('workouts.DURATION')) + ":", 1),
                        _createElementVNode("div", null, [
                          _withDirectives(_createElementVNode("input", {
                            id: "workout-duration-hour",
                            name: "workout-duration-hour",
                            class: "workout-duration",
                            type: "text",
                            placeholder: "HH",
                            pattern: "^([0-1]?[0-9]|2[0-3])$",
                            required: "",
                            onInvalid: invalidateForm,
                            disabled: _unref(loading),
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(workoutForm).workoutDurationHour) = $event))
                          }, null, 40, _hoisted_26), [
                            [_vModelText, _unref(workoutForm).workoutDurationHour]
                          ]),
                          _hoisted_27,
                          _withDirectives(_createElementVNode("input", {
                            id: "workout-duration-minutes",
                            name: "workout-duration-minutes",
                            class: "workout-duration",
                            type: "text",
                            pattern: "^([0-5][0-9])$",
                            placeholder: "MM",
                            required: "",
                            onInvalid: invalidateForm,
                            disabled: _unref(loading),
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(workoutForm).workoutDurationMinutes) = $event))
                          }, null, 40, _hoisted_28), [
                            [_vModelText, _unref(workoutForm).workoutDurationMinutes]
                          ]),
                          _hoisted_29,
                          _withDirectives(_createElementVNode("input", {
                            id: "workout-duration-seconds",
                            name: "workout-duration-seconds",
                            class: "workout-duration",
                            type: "text",
                            pattern: "^([0-5][0-9])$",
                            placeholder: "SS",
                            required: "",
                            onInvalid: invalidateForm,
                            disabled: _unref(loading),
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(workoutForm).workoutDurationSeconds) = $event))
                          }, null, 40, _hoisted_30), [
                            [_vModelText, _unref(workoutForm).workoutDurationSeconds]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.$t('workouts.DISTANCE')) + " (" + _toDisplayString(_unref(authUser).imperial_units ? 'mi' : 'km') + "): ", 1),
                      _withDirectives(_createElementVNode("input", {
                        name: "workout-distance",
                        type: "number",
                        min: "0",
                        step: "0.001",
                        required: "",
                        onInvalid: invalidateForm,
                        disabled: _unref(loading),
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(workoutForm).workoutDistance) = $event))
                      }, null, 40, _hoisted_32), [
                        [_vModelText, _unref(workoutForm).workoutDistance]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t('workouts.NOTES')) + ": ", 1),
                _createVNode(_component_CustomTextArea, {
                  name: "notes",
                  input: _unref(workoutForm).notes,
                  disabled: _unref(loading),
                  onUpdateValue: updateNotes
                }, null, 8, ["input", "disabled"])
              ])
            ]),
            (_unref(errorMessages))
              ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                  key: 0,
                  message: _unref(errorMessages)
                }, null, 8, ["message"]))
              : _createCommentVNode("", true),
            (_unref(loading))
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createVNode(_component_Loader)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createElementVNode("button", {
                    class: "confirm",
                    type: "submit",
                    disabled: _unref(loading)
                  }, _toDisplayString(_ctx.$t('buttons.SUBMIT')), 9, _hoisted_36),
                  _createElementVNode("button", {
                    class: "cancel",
                    onClick: _withModifiers(onCancel, ["prevent"])
                  }, _toDisplayString(_ctx.$t('buttons.CANCEL')), 9, _hoisted_37)
                ]))
          ], 42, _hoisted_2)
        ])
      ]),
      _: 1
    })
  ], 2))
}
}

})